CDN.requireOnce([
    { code: CDN.PackageCode.Common, },
    { code: CDN.PackageCode.Control_Collection, },
    { code: CDN.PackageCode.Control_Login, },
    { code: CDN.PackageCode.Control_UI_Input, },
    { code: CDN.PackageCode.API_AutoComplete_v1, },    
], () => {
    $(document).ready(Pages.Test._Controls.Permission.__cdn_pages_test_controls_collectionitemmanager_onDocumentReadyAsync);
});

namespace Pages.Test._Controls.Permission {
    export async function __cdn_pages_test_controls_collectionitemmanager_onDocumentReadyAsync() {
        let main = document.querySelector('main');

        let login = new CDN.Controls.Login(main, {
            onLogin: (result) => {
                login.hide();

                let vehicleSearchInput = new CDN.Controls.UI.TextInput<CDN.API.AutoComplete.v1.Vehicle>(main, {
                    label: 'Registration',
                    placeholder: 'Search',
                    autocomplete: {
                        minLength: 2,
                        searchAsync: async (term, cancellationToken) => {
                            let vehicles = await CDN.API.AutoComplete.v1.searchAllVehiclesAsync({
                                userToken: result.UserToken,
                                productId: CDN.Common.ProductId.ERP,
                            }, term, cancellationToken);

                            return vehicles.map(v => {
                                return {
                                    label: v.Registration,
                                    value: v.Registration,
                                    data: v,
                                };
                            });
                        },
                        onSelect: vehicle => {
                            itemCollectionManager.setItemAsync({
                                collectionType: CDN.API.Collection.v1.CollectionType.ClientVehicle,
                                foreignKeyId: CDN.Common.ForeignKey.VehicleId,
                                foreignKeyValue: vehicle.ErpVehicleId,
                                parentId: 0,
                                data: vehicle,
                            });
                        },
                    },

                });
                vehicleSearchInput.container.style.width = '400px';

                main.append(document.createElement('br'));

                let itemCollectionManager = new CDN.Controls.Collection.ItemCollectionManager<CDN.API.AutoComplete.v1.Vehicle>(main, {
                    userToken: result.UserToken,                    
                });

                main.append(document.createElement('br'));
            }
        });

    }
}
